import { Stack, styled } from '@mui/material';

const StackContainer = styled(Stack)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    flexWrap: 'nowrap',
    width: '100%',
    overflowX: 'auto',
    scrollSnapType: 'x mandatory',
    '::-webkit-scrollbar': {
      display: 'none',
    },
  },
}));

export { StackContainer };
